const doc = [({"zh_tw":({"adminConstantMessageType":({"button":"按鈕", "carousels":"旋轉木馬", "externalImage":"外部圖像", "image":"圖片", "quickReply":"快速回复", "text":"文本"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;